export default __webpack_public_path__ + "static/media/Jaguar-new.99f0287a.jpeg";